import { handleActions } from 'redux-actions';
import { combineReducers } from 'redux';
import { getReportFactory, getReportFactoryFailure, getReportFactoryIdle, getReportFactorySuccess } from '../actions';

const status_get_report_factory = handleActions(
  {
    [getReportFactory.toString()]: (state, action) => 'LOADING',
    [getReportFactorySuccess.toString()]: (state, action) => 'SUCCESS',
    [getReportFactoryFailure.toString()]: (state, action) => 'FAILURE',
    [getReportFactoryIdle.toString()]: (state, action) => 'IDLE',
  },
  'IDLE'
);

const data_get_report_factory = handleActions(
  {
    [getReportFactory.toString()]: () => null,
    [getReportFactorySuccess.toString()]: (state, action) => action.payload,
    
  },
  null
);

export { status_get_report_factory, data_get_report_factory };
